/* ─────────────────────────────────────────────────────────────────────────────
   LA PERSONALIZACIÓN SIGUE A SU PRODUCTO (5-oct-2026)

   Padrino: «si el cliente pide más del producto, quiero que la personalización
   que se le cobra a ese producto suba también». Desde R4 una caja personalizada
   son DOS líneas del carrito —la caja y su cobro, «Personalización · 25
   piezas»— y el cobro va FIRMADO para la cantidad con la que se aprobó. Hasta
   hoy su stepper venía apagado en /cart y en Paco: para pedir otro paquete había
   que volver al estudio.

   Este módulo es el ÚNICO dueño de «mover una caja personalizada» en el tema.
   Lo usan /cart (sections/main-cart-items.liquid), el carrito de Paco
   (assets/pp-paco3.js) y «Volver a pedir». Expone window.PPPersonalizacion:

     aparear(items)             caja ↔ su cobro (la misma regla del estudio)
     esRecotizable(item)        ¿se le puede mover la cantidad aquí?
     cambiarPaquetes(llave, n)  la caja a n paquetes y su cobro detrás (n=0: quita las dos)
     recomprar(linea)           una caja de un pedido, con su personalización
     etiquetaDelCobro(cobro, caja)  «Impresión de tu diseño · 2 caras · 50 cajas de 26 × 13 × 14 cm»

   EL PRECIO NUNCA SALE DE AQUÍ. La cantidad nueva se manda al servidor
   (edge `ps-recotizar-linea`, monorepo), que recotiza con la ley —el precio
   por pieza depende de los paquetes— y devuelve el recibo firmado nuevo. Este
   archivo sólo copia ese recibo a las dos líneas. Y la red
   (`cobro-personalizacion`) corre en CADA cambio del carrito, no sólo al
   pagar: un carrito desparejado ni siquiera llega a existir (medido el 5-oct:
   422 al intentarlo). Por eso cada cambio entra como un par completo.
   ───────────────────────────────────────────────────────────────────────────── */
(function (raiz) {
  'use strict';

  // Lo que la caja trae FIRMADO (o de régimen) y el recibo nuevo reemplaza.
  // `_ps_paquetes` (v3, 6-oct-2026): los paquetes firmados; un recibo v2 no lo trae.
  var LLAVES_DEL_RECIBO = ['_ps_perso_por_pieza', '_ps_piezas_por_pack', '_ps_caras', '_ps_lados', '_ps_paquetes', '_ps_firma', '_ps_v'];

  function props(it) {
    var p = it && it.properties;
    return p && typeof p === 'object' ? p : {};
  }
  function valor(it, llave) {
    var v = props(it)[llave];
    return v == null ? '' : String(v);
  }
  function esCobro(it) { return !!valor(it, '_ps_servicio'); }
  function esGrabado(it) { return !!valor(it, '_ps_grabado_de'); }
  function esCaja(it) { return !!valor(it, '_design_id') && !esCobro(it) && !esGrabado(it); }
  function esCinta(it) { return valor(it, '_ps_caras').charAt(0) === 'G'; }

  /** ¿A esta caja se le puede mover la cantidad desde el carrito? Sólo las del
   * régimen de dos líneas, con recibo completo, y no las cintas (su ley lleva
   * grabado y se cambian en el estudio). */
  function esRecotizable(it) {
    return esCaja(it) && valor(it, '_ps_v') === '2' && !!valor(it, '_ps_firma') &&
      Number(valor(it, '_ps_piezas_por_pack')) > 0 && !esCinta(it);
  }

  function piezasEsperadas(caja) {
    return Number(valor(caja, '_ps_piezas_por_pack')) * Number(caja.quantity || 0);
  }

  /**
   * A cada caja, SU cobro. La misma regla que el estudio
   * (features/estudio/lineasDelCarrito.ts `cobroDeCadaCaja`), en el mismo orden:
   *   1. por aprobación: la caja y su cobro comparten `_ps_pareja`;
   *   2. por dueño: el `_ps_de` del cobro es la `_ps_firma` de la caja;
   *   3. carritos viejos: mismo diseño y cantidad = piezas × paquetes.
   * Uno a uno: el mismo diseño puede estar dos veces (orden #150356).
   * Devuelve { cobroDe: {llaveCaja: cobro}, cajaDe: {llaveCobro: caja} }.
   */
  function aparear(items) {
    var lista = Array.isArray(items) ? items : [];
    var cobros = lista.filter(esCobro);
    var cajas = lista.filter(esCaja);
    var usados = {};
    var cobroDe = {}, cajaDe = {};
    function unir(caja, cobro) {
      if (!cobro) return;
      usados[cobro.key] = true;
      cobroDe[caja.key] = cobro;
      cajaDe[cobro.key] = caja;
    }
    function libre(c) { return !usados[c.key]; }
    cajas.forEach(function (caja) {
      var pareja = valor(caja, '_ps_pareja');
      if (pareja) unir(caja, cobros.filter(libre).filter(function (c) { return valor(c, '_ps_pareja') === pareja; })[0]);
    });
    cajas.forEach(function (caja) {
      if (cobroDe[caja.key]) return;
      var firma = valor(caja, '_ps_firma');
      if (firma) unir(caja, cobros.filter(libre).filter(function (c) { return valor(c, '_ps_de') === firma; })[0]);
    });
    cajas.forEach(function (caja) {
      if (cobroDe[caja.key]) return;
      var d = valor(caja, '_design_id');
      var esperada = piezasEsperadas(caja);
      unir(caja, cobros.filter(libre).filter(function (c) {
        return valor(c, '_design_id') === d && (!(esperada > 0) || Number(c.quantity) === esperada);
      })[0]);
    });
    return { cobroDe: cobroDe, cajaDe: cajaDe };
  }

  // ── EL NOMBRE DEL COBRO (6-oct-2026) ────────────────────────────────────
  //
  // Padrino: «lo más claros posible, quitar toda pregunta del cliente».
  //   caja/bolsa/sobre  «Impresión de tu diseño · 2 caras · 250 cajas de 26 × 13 × 14 cm»
  //   cinta             «Tinta extra (2.ª tinta) · 40 rollos»
  // El MISMO texto lo pone el cart transform en el checkout (repo
  // parapaquetes-shopify-app, `nombre_del_cobro`), snippets/pp-nombre-del-cobro.liquid
  // en /cart y el estudio (monorepo). Los cuatro se carean contra
  // tests/nombres-del-cobro.json (tests/el-nombre-del-cobro.test.mjs).

  function empiezaCon(tipo, prefijo) {
    return String(tipo || '').trim().toLowerCase().indexOf(prefijo) === 0;
  }
  function esCintaPor(tipo, caras) {
    return String(caras || '').charAt(0) === 'G' || empiezaCon(tipo, 'cinta');
  }
  function unidadDelTipo(tipo, n) {
    var uno = n === 1;
    if (empiezaCon(tipo, 'cinta')) return uno ? 'rollo' : 'rollos';
    if (empiezaCon(tipo, 'caja')) return uno ? 'caja' : 'cajas';
    if (empiezaCon(tipo, 'bolsa')) return uno ? 'bolsa' : 'bolsas';
    if (empiezaCon(tipo, 'sobre')) return uno ? 'sobre' : 'sobres';
    return uno ? 'pieza' : 'piezas';
  }
  /** 1234 → «1,234», sin depender del Intl del navegador. */
  function miles(n) {
    return String(Math.abs(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  /** Las tintas de una cinta, de su exigencia de grabado firmada («G2@929.00»). */
  function tintasDeLaCinta(caras) {
    var m = /^G(\d+)@/.exec(String(caras || ''));
    var n = m ? Number(m[1]) : 0;
    return n >= 2 && n <= 9 ? n : 0;
  }
  function carasImpresas(caras) {
    var c = String(caras || '');
    if (c.charAt(0) === 'G') return 0;
    return c.split(',').filter(function (x) { return /^\d+$/.test(x.trim()); }).length;
  }

  /** El nombre COMPLETO del cobro. `n` = cantidad del renglón del cobro. */
  function nombreDelCobro(n, tipo, caras, medida) {
    n = Number(n) || 0;
    var cinta = esCintaPor(tipo, caras);
    var cuantas = miles(n) + ' ' + unidadDelTipo(cinta ? 'cinta' : tipo, n);
    if (cinta) {
      var t = tintasDeLaCinta(caras);
      if (t === 2) return 'Tinta extra (2.ª tinta) · ' + cuantas;
      if (t === 3) return 'Tintas extra (2.ª y 3.ª) · ' + cuantas;
      if (t > 3) return 'Tintas extra (2.ª a ' + t + '.ª) · ' + cuantas;
      return 'Tinta extra · ' + cuantas;
    }
    var s = 'Impresión de tu diseño';
    var k = carasImpresas(caras);
    if (k === 1) s += ' · 1 cara';
    else if (k > 1) s += ' · ' + k + ' caras';
    s += ' · ' + cuantas;
    var m = String(medida || '').trim();
    if (m && Array.from(m).length <= 40) s += ' de ' + m;
    return s;
  }

  /** El nombre CORTO (el del checkout con más de 25 personalizaciones). */
  function nombreCortoDelCobro(n, tipo, caras) {
    n = Number(n) || 0;
    if (esCintaPor(tipo, caras)) return 'Tinta extra · ' + miles(n) + ' ' + unidadDelTipo('cinta', n);
    return 'Impresión de tu diseño · ' + miles(n) + ' ' + unidadDelTipo(tipo, n);
  }

  /** El cobro con SU caja: la unidad sale del tipo de la caja (`product_type`
   * de /cart.js), las caras y tintas de su firma y la medida de `_medida`. */
  function etiquetaDelCobro(cobro, caja) {
    var n = Number(cobro && cobro.quantity) || 0;
    if (!caja) return nombreCortoDelCobro(n, '', '');
    return nombreDelCobro(n, caja.product_type || '', valor(caja, '_ps_caras'), valor(caja, '_medida'));
  }

  /** La unidad (singular) del cobro de esta caja: «caja», «rollo», «bolsa»… */
  function unidadDelCobro(caja) {
    var tipo = caja ? caja.product_type || '' : '';
    return unidadDelTipo(esCintaPor(tipo, valor(caja, '_ps_caras')) ? 'cinta' : tipo, 1);
  }

  /** El grabado de una cinta (TINTA-01 × tintas): «Grabado de 2 tintas · se paga una sola vez». */
  function etiquetaDelGrabado(grabado) {
    var n = Number(grabado && grabado.quantity) || 0;
    return 'Grabado de ' + (n === 1 ? '1 tinta' : n + ' tintas') + ' · se paga una sola vez';
  }

  // ── Red ─────────────────────────────────────────────────────────────────

  function urlRecotizar() {
    var n = raiz.document && raiz.document.querySelector('[data-pp-recotizar-url]');
    var u = n ? n.getAttribute('data-pp-recotizar-url') : '';
    return u || '';
  }

  function rutaUpdate() {
    var r = raiz.routes || {};
    return (r.cart_update_url || '/cart/update') + '.js';
  }

  function rutaCarrito(cual) {
    var r = raiz.routes || {};
    var base = { change: r.cart_change_url || '/cart/change', add: r.cart_add_url || '/cart/add' }[cual];
    return base + '.js';
  }

  function pedirJson(url, cuerpo) {
    return raiz.fetch(url, {
      method: cuerpo ? 'POST' : 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: cuerpo ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
      body: cuerpo ? JSON.stringify(cuerpo) : undefined,
    }).then(function (res) {
      return Promise.resolve(res.json ? res.json().catch(function () { return null; }) : null).then(function (j) {
        if (!res.ok) {
          var e = new Error((j && (j.mensaje || j.description || j.message)) || 'HTTP ' + res.status);
          e.status = res.status;
          e.codigo = j && j.codigo;
          throw e;
        }
        return j;
      });
    });
  }

  function leerCarrito() { return pedirJson('/cart.js'); }

  /** Pide al servidor el recibo de esta caja a `paquetes`. */
  function recotizar(caja, paquetes) {
    var url = urlRecotizar();
    if (!url) return Promise.reject(new Error('Esta personalización se cambia en el estudio.'));
    return raiz.fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        design_id: valor(caja, '_design_id'),
        perso_por_pieza: valor(caja, '_ps_perso_por_pieza'),
        piezas_por_pack: valor(caja, '_ps_piezas_por_pack'),
        caras: valor(caja, '_ps_caras'),
        lados: valor(caja, '_ps_lados'),
        firma: valor(caja, '_ps_firma'),
        // v3: un recibo que firmó sus paquetes se verifica CON ellos.
        paquetes_firmados: valor(caja, '_ps_paquetes'),
        paquetes: paquetes,
      }),
    }).then(function (res) {
      return res.json().catch(function () { return null; }).then(function (j) {
        if (!res.ok || !j || j.ok !== true) {
          var e = new Error((j && j.mensaje) || 'No pudimos actualizar tu personalización. Inténtalo otra vez.');
          e.codigo = j && j.codigo;
          throw e;
        }
        return j;
      });
    });
  }

  function aObjeto(lista) {
    var o = {};
    (lista || []).forEach(function (a) { if (a && a.key) o[a.key] = a.value; });
    return o;
  }

  /** Los atributos de la caja con el recibo NUEVO: todo lo de producción se
   * queda (mockup, medida, archivos, caras rotuladas, la pareja), lo firmado se
   * reemplaza entero y `_pieces_total` se pone al día. */
  function propiedadesDeLaCaja(anteriores, r) {
    var p = {};
    Object.keys(anteriores || {}).forEach(function (k) {
      if (LLAVES_DEL_RECIBO.indexOf(k) === -1) p[k] = anteriores[k];
    });
    var nuevos = aObjeto(r.firmados);
    Object.keys(nuevos).forEach(function (k) { p[k] = nuevos[k]; });
    if (r.marca_de_regimen && r.marca_de_regimen.key) p[r.marca_de_regimen.key] = r.marca_de_regimen.value;
    p._pieces_total = String(r.total_piezas);
    return p;
  }

  function propiedadesDelCobro(r, pareja) {
    var p = aObjeto(r.renglon_servicio && r.renglon_servicio.atributos);
    if (pareja) p._ps_pareja = pareja;
    return p;
  }

  function idNumerico(gid) {
    var m = String(gid || '').match(/(\d+)$/);
    return m ? Number(m[1]) : null;
  }

  function nuevaPareja() {
    try { if (raiz.crypto && raiz.crypto.randomUUID) return raiz.crypto.randomUUID(); } catch (_) {}
    return 'p-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  // Un cambio a la vez: dos «+» seguidos no pueden recotizar sobre el mismo
  // recibo viejo y pisarse.
  var cola = Promise.resolve();
  function encolar(trabajo) {
    var corrida = cola.then(trabajo, trabajo);
    cola = corrida.catch(function () {});
    return corrida;
  }

  function quitarJuntas(cart, caja) {
    var par = aparear(cart.items);
    var updates = {};
    updates[caja.key] = 0;
    var cobro = par.cobroDe[caja.key];
    if (cobro) updates[cobro.key] = 0;
    // El grabado de una cinta también se va con ella (la red no deja dejarlo).
    var d = valor(caja, '_design_id'), pareja = valor(caja, '_ps_pareja');
    (cart.items || []).forEach(function (it) {
      if (valor(it, '_ps_grabado_de') === d && (!pareja || valor(it, '_ps_pareja') === pareja)) updates[it.key] = 0;
    });
    return pedirJson(rutaUpdate(), { updates: updates });
  }

  /**
   * La caja `llave` a `paquetes` y su cobro detrás. Con 0, se quitan juntas.
   * Resuelve con el carrito nuevo; rechaza con un Error cuyo `message` ya se le
   * puede enseñar al cliente (el mínimo, «tu diseño cambió…»), sin haber tocado
   * nada si el servidor dijo que no.
   *
   * POR QUÉ NO SE CAMBIAN LAS DOS LÍNEAS EN SU LUGAR (medido en la tienda el
   * 5-oct-2026): la validación `cobro-personalizacion` corre en CADA cambio del
   * carrito, no sólo al pagar. Cambiar la caja a 2 paquetes con su cobro todavía
   * en 25 piezas es un carrito desparejado y Shopify lo rechaza (422, «No
   * pudimos confirmar el precio de tu personalización…»); y al revés, igual. No
   * hay una llamada que cambie cantidad Y atributos de dos líneas a la vez. Así
   * que se hace como el estudio: la versión NUEVA (caja + cobro, con una pareja
   * nueva) entra en UNA llamada —el carrito queda con dos pares, cada uno
   * cuadrado—, y la vieja sale en OTRA —un par entero—. Nunca hay un instante
   * desparejado, y por eso la red puede seguir bloqueando todo lo que lo esté.
   */
  function cambiarPaquetes(llave, paquetes) {
    return encolar(function () {
      return leerCarrito().then(function (cart) {
        var caja = (cart.items || []).filter(function (it) { return it.key === llave; })[0];
        if (!caja) throw new Error('Esa caja ya no está en tu carrito.');
        if (!(paquetes > 0)) return quitarJuntas(cart, caja);
        if (!esRecotizable(caja)) throw new Error('Esta personalización se cambia en el estudio.');
        var cobro = aparear(cart.items).cobroDe[caja.key] || null;
        return recotizar(caja, paquetes).then(function (r) {
          var pareja = nuevaPareja();
          var pc = propiedadesDeLaCaja(props(caja), r);
          pc._ps_pareja = pareja;
          var renglon = r.renglon_servicio;
          // El cobro PRIMERO: /cart/add.js pone hasta arriba lo último que
          // recibe, así la caja queda arriba y su cobro justo debajo (también
          // en el checkout, que no se puede reordenar de otra forma).
          return pedirJson(rutaCarrito('add'), {
            items: [
              { id: idNumerico(renglon.variant_id), quantity: renglon.cantidad, properties: propiedadesDelCobro(r, pareja) },
              { id: Number(caja.variant_id), quantity: paquetes, properties: pc },
            ],
          }).then(function () {
            var updates = {};
            updates[caja.key] = 0;
            if (cobro) updates[cobro.key] = 0;
            return pedirJson(rutaUpdate(), { updates: updates }).catch(function () {
              throw new Error('Agregamos la cantidad nueva pero no pudimos quitar la anterior: quita la caja repetida.');
            });
          });
        });
      });
    });
  }

  /**
   * «Volver a pedir» una caja personalizada de un pedido: el MISMO diseño ya
   * aprobado, a los paquetes de entonces (o los que diga `paquetes`), al
   * precio de HOY. La caja y su cobro entran en UNA llamada con una pareja
   * nueva — como las mete el estudio —, así no se juntan con otra del mismo diseño.
   * `linea` = { variant_id, quantity, atributos: [{key,value}] | {k:v} }.
   */
  function recomprar(linea, paquetes) {
    var attrs = Array.isArray(linea.atributos) ? aObjeto(linea.atributos) : (linea.atributos || {});
    var caja = { key: 'pedido', quantity: linea.quantity, properties: attrs };
    var n = paquetes > 0 ? paquetes : Number(linea.quantity) || 1;
    // Del pedido basta el recibo firmado (los de antes de R4 no traen `_ps_v`):
    // la caja nueva nace en el régimen de dos líneas igual.
    var conRecibo = esCaja(caja) && !!valor(caja, '_ps_firma') && Number(valor(caja, '_ps_piezas_por_pack')) > 0 && !esCinta(caja);
    if (!conRecibo) return Promise.reject(new Error('Lleva tu diseño: se vuelve a pedir desde el estudio.'));
    return encolar(function () {
      return recotizar(caja, n).then(function (r) {
        var pareja = nuevaPareja();
        var limpias = {};
        Object.keys(attrs).forEach(function (k) {
          // Lo del pedido que NO es de la caja nueva: su pareja vieja y las marcas del cobro.
          if (k !== '_ps_pareja' && k !== '_ps_servicio' && k !== '_ps_de') limpias[k] = attrs[k];
        });
        var pc = propiedadesDeLaCaja(limpias, r);
        pc._ps_pareja = pareja;
        var renglon = r.renglon_servicio;
        // El cobro primero (ver cambiarPaquetes): la caja arriba, su cobro debajo.
        return pedirJson(rutaCarrito('add'), {
          items: [
            { id: idNumerico(renglon.variant_id), quantity: renglon.cantidad, properties: propiedadesDelCobro(r, pareja) },
            { id: Number(linea.variant_id), quantity: n, properties: pc },
          ],
        }).then(function () { return r; });
      });
    });
  }

  // ── «VOLVER A PEDIR» CON CONFIRMACIÓN (Padrino, 6-oct-2026) ─────────────
  //
  // Recomprar una caja personalizada NO la agrega a ciegas: el cliente ve el
  // diseño que aprobó (el mockup que guardó el estudio, `_mockup_url`) y
  // escoge. Es impresión, no serigrafía: cambiar no cuesta nada — esto es sólo
  // para que confirme que no hay nada que cambiar.
  //   «Dejar igual»   → recomprar(): la caja y su cobro, en un toque.
  //   «Cambiar algo»  → el estudio con ESE diseño cargado (la liga firmada de
  //                     «Mis diseños», que abre una copia para editarla).

  var ESTUDIO = 'https://print.parapaquetes.com/estudio/';
  var MIS_DISENOS = '/pages/cliente-disenos';

  /** La liga al estudio con ESE diseño (la de «Mis diseños»: firmada, caduca
   * en 30 min, por eso se pide al picar). Sin ella, «Mis diseños». */
  function urlParaCambiar(designId) {
    return raiz.fetch('/apps/crm/customer-disenos', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var lista = d && Array.isArray(d.comprados) ? d.comprados : [];
        var t = lista.filter(function (x) { return x && x.id === designId; })[0];
        var u = t && typeof t.abrir_url === 'string' ? t.abrir_url : '';
        return u.indexOf(ESTUDIO) === 0 ? u : MIS_DISENOS;
      }, function () { return MIS_DISENOS; });
  }

  var TEXTOS = {
    titulo: 'Vas a volver a pedir tu caja personalizada.',
    pregunta: 'Este es el diseño que aprobaste. ¿Lo dejamos igual o le quieres cambiar algo?',
    igual: 'Dejar igual',
    cambiar: 'Cambiar algo',
    agregando: 'Agregando…',
    abriendo: 'Abriendo el estudio…',
    listo: 'Listo: la agregué a tu carrito con su personalización, al precio de hoy.',
  };

  var estiloPuesto = false;
  function ponerEstilo() {
    if (estiloPuesto || !raiz.document) return;
    estiloPuesto = true;
    var st = raiz.document.createElement('style');
    st.setAttribute('data-pp-perso-confirma-estilo', '');
    st.textContent =
      '.pp-perso-confirma{display:grid;grid-template-columns:88px minmax(0,1fr);gap:12px;align-items:start;padding:12px;border:1px solid #E4DDD0;border-radius:12px;background:#fff;margin:8px 0}' +
      '.pp-perso-confirma__img{width:88px;height:88px;object-fit:contain;border:1px solid #EFE9DD;border-radius:8px;background:#F7F4EE}' +
      '.pp-perso-confirma__titulo{margin:0 0 2px;font-weight:700;font-size:14px;line-height:1.3;color:#0F2A44}' +
      '.pp-perso-confirma__texto{margin:0 0 4px;font-size:13px;line-height:1.4;color:#3B4A5A}' +
      '.pp-perso-confirma__de{margin:0 0 8px;font-size:12px;color:#5B6B7B}' +
      '.pp-perso-confirma__acciones{display:flex;flex-wrap:wrap;gap:8px}' +
      '.pp-perso-confirma__acciones button{min-height:36px;padding:0 14px;border-radius:999px;font-weight:700;font-size:13px;cursor:pointer;border:1px solid #0F2A44}' +
      '.pp-perso-confirma__igual{background:#0F2A44;color:#fff}' +
      '.pp-perso-confirma__cambiar{background:#fff;color:#0F2A44}' +
      '.pp-perso-confirma__acciones button[disabled]{opacity:.55;cursor:default}' +
      '.pp-perso-confirma__estado{margin:8px 0 0;font-size:13px;color:#2F7D5B}' +
      '.pp-perso-confirma__estado--error{color:#B42318}' +
      '@media (hover:hover){.pp-perso-confirma__igual:hover{background:#163A5E}.pp-perso-confirma__cambiar:hover{background:#F2F5F8}}';
    raiz.document.head.appendChild(st);
  }

  /**
   * La tarjeta de confirmación. `linea` = { variant_id, quantity, atributos,
   * titulo }. `alTerminar(ok)` se llama tras «Dejar igual» (para releer el
   * carrito). `opciones.pestanaNueva` (Paco, 8-oct-2026): «Cambiar algo» abre
   * el estudio en pestaña nueva — la pestaña se abre EN el clic (si no, el
   * navegador la bloquea) y recibe la liga firmada cuando llega. Sin
   * opciones (Compra Rápida), la misma pestaña. Devuelve el nodo.
   */
  function tarjetaDeRecompra(linea, alTerminar, opciones) {
    var enPestanaNueva = !!(opciones && opciones.pestanaNueva);
    var doc = raiz.document;
    ponerEstilo();
    var attrs = Array.isArray(linea.atributos) ? aObjeto(linea.atributos) : (linea.atributos || {});
    function el(tag, clase, texto) {
      var n = doc.createElement(tag);
      if (clase) n.className = clase;
      if (texto != null) n.textContent = texto;
      return n;
    }
    var caja = el('div', 'pp-perso-confirma');
    caja.setAttribute('data-pp-perso-confirma', attrs._design_id || '');
    var img = el('img', 'pp-perso-confirma__img');
    img.alt = 'El diseño que aprobaste';
    img.loading = 'lazy';
    if (/^https:\/\//.test(attrs._mockup_url || '')) img.src = attrs._mockup_url;
    caja.appendChild(img);
    var cuerpo = el('div', 'pp-perso-confirma__cuerpo');
    cuerpo.appendChild(el('p', 'pp-perso-confirma__titulo', TEXTOS.titulo));
    cuerpo.appendChild(el('p', 'pp-perso-confirma__texto', TEXTOS.pregunta));
    var n = Number(linea.quantity) || 1;
    var de = (attrs._medida || linea.titulo || '') + ' · ' + n + (n === 1 ? ' paquete' : ' paquetes');
    cuerpo.appendChild(el('p', 'pp-perso-confirma__de', de));
    var acciones = el('div', 'pp-perso-confirma__acciones');
    var igual = el('button', 'pp-perso-confirma__igual', TEXTOS.igual);
    igual.type = 'button';
    igual.setAttribute('data-pp-perso-igual', '');
    var cambiar = el('button', 'pp-perso-confirma__cambiar', TEXTOS.cambiar);
    cambiar.type = 'button';
    cambiar.setAttribute('data-pp-perso-cambiar', '');
    acciones.appendChild(igual);
    acciones.appendChild(cambiar);
    cuerpo.appendChild(acciones);
    var estado = el('p', 'pp-perso-confirma__estado');
    estado.setAttribute('role', 'status');
    estado.hidden = true;
    cuerpo.appendChild(estado);
    caja.appendChild(cuerpo);
    function decir(t, error) {
      estado.textContent = t;
      estado.hidden = !t;
      estado.classList.toggle('pp-perso-confirma__estado--error', !!error);
    }
    igual.addEventListener('click', function () {
      igual.disabled = true; cambiar.disabled = true;
      igual.textContent = TEXTOS.agregando;
      recomprar({ variant_id: linea.variant_id, quantity: n, atributos: attrs }).then(function () {
        acciones.hidden = true;
        decir(TEXTOS.listo, false);
        if (alTerminar) alTerminar(true);
      }, function (e) {
        igual.disabled = false; cambiar.disabled = false;
        igual.textContent = TEXTOS.igual;
        decir((e && e.message) || 'No pude agregarla. Inténtalo otra vez.', true);
        if (alTerminar) alTerminar(false);
      });
    });
    cambiar.addEventListener('click', function () {
      igual.disabled = true; cambiar.disabled = true;
      cambiar.textContent = TEXTOS.abriendo;
      var w = null;
      if (enPestanaNueva) { try { w = raiz.open('', '_blank'); } catch (_) { w = null; } }
      urlParaCambiar(attrs._design_id || '').then(function (u) {
        if (!w) { raiz.location.href = u; return; }
        // Paco se queda: el botón vuelve a su texto por si quiere otra vez.
        cambiar.textContent = TEXTOS.cambiar;
        igual.disabled = false; cambiar.disabled = false;
        if (w.closed) return;
        try { w.opener = null; } catch (_) { /* ya sin opener */ }
        w.location.href = u;
      });
    });
    return caja;
  }

  raiz.PPPersonalizacion = {
    tarjetaDeRecompra: tarjetaDeRecompra,
    urlParaCambiar: urlParaCambiar,
    textosDeRecompra: TEXTOS,
    aparear: aparear,
    esRecotizable: esRecotizable,
    esCobro: esCobro,
    esCaja: esCaja,
    cambiarPaquetes: cambiarPaquetes,
    recomprar: recomprar,
    etiquetaDelCobro: etiquetaDelCobro,
    etiquetaDelGrabado: etiquetaDelGrabado,
    unidadDelCobro: unidadDelCobro,
    nombreDelCobro: nombreDelCobro,
    nombreCortoDelCobro: nombreCortoDelCobro,
    // Para las pruebas.
    _propiedadesDeLaCaja: propiedadesDeLaCaja,
  };
})(typeof window !== 'undefined' ? window : this);
